import { render } from "./Module.vue?vue&type=template&id=29d5d104&scoped=true&ts=true"
import script from "./Module.vue?vue&type=script&lang=ts"
export * from "./Module.vue?vue&type=script&lang=ts"

import "./Module.vue?vue&type=style&index=0&id=29d5d104&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d5d104"]])

export default __exports__